import React from 'react';
import { Container, Divider } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { currencyFormat } from '@fiverr-private/localization';
import { CustomOrderButton } from '../../CustomOrder';
import { PortfolioProjectPrice } from '../utils';
import { DETAILS_SECTION_WIDTH } from '../consts';

interface DetailsSectionProps {
    selectedSkillName: string;
    startingPrice?: PortfolioProjectPrice;
    onCustomOrderClick: () => void;
}

export const DetailsSection = ({ selectedSkillName, startingPrice, onCustomOrderClick }: DetailsSectionProps) => (
    <>
        <Container
            display={{
                default: 'none',
                md: 'flex',
            }}
            direction="column"
            flexShrink="0"
            width={`${DETAILS_SECTION_WIDTH}px`}
            justifyContent="spaceBetween"
        >
            <Heading as="h4" wordBreak="keepAll">
                {selectedSkillName}
            </Heading>
            <Container>
                {startingPrice && (
                    <>
                        <Text color="bodySecondary">
                            <I18n k="seller_page_perseus.portfolio_slider.from" />
                        </Text>
                        <Heading as="h6">
                            {currencyFormat({
                                value: startingPrice.amount,
                                currencyCode: startingPrice.currency,
                            })}
                        </Heading>
                    </>
                )}
                <Container marginTop="3">
                    <CustomOrderButton
                        buttonText="seller_page_perseus.portfolio_slider.get_custom_offer"
                        onClick={onCustomOrderClick}
                    />
                </Container>
            </Container>
        </Container>
        <Container
            display={{
                default: 'none',
                md: 'flex',
            }}
            height="256px"
        >
            <Divider direction="vertical" />
        </Container>
    </>
);
